import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";

const topics = [
  {
    title: "棚录七十二小时",
    desc: "一档综艺从彩排到成片，现场几百号人如何把临场反应留进镜头。",
    tag: "综艺专题",
    href: "/category/variety",
    image:
      "https://readdy.ai/api/search-image?query=Television%20variety%20studio%20stage%20with%20colorful%20lighting%20rigs%20and%20empty%20host%20podium%2C%20warm%20amber%20and%20coral%20tone%2C%20stylized%20editorial%20photography%2C%20no%20people%2C%20high%20detail&width=800&height=600&seq=hl-topic-variety&orientation=landscape",
  },
  {
    title: "剧组江湖录",
    desc: "灯光、场务、服化道与生活制片，一部戏背后数百人的协作生态。",
    tag: "剧组专题",
    href: "/category/crew",
    image:
      "https://readdy.ai/api/search-image?query=Film%20crew%20equipment%20corner%20with%20light%20stands%20cables%20and%20tool%20boxes%20on%20a%20warm%20lit%20wooden%20stage%2C%20stylized%20editorial%20photography%2C%20craft%20texture%2C%20no%20people%2C%20high%20detail&width=800&height=600&seq=hl-topic-crew&orientation=landscape",
  },
  {
    title: "被删掉的三分钟",
    desc: "预告里见过的镜头为何没进成片，剪辑台的取舍逻辑全解析。",
    tag: "剪辑专题",
    href: "/category/editing",
    image:
      "https://readdy.ai/api/search-image?query=Dark%20editing%20room%20desk%20with%20dual%20monitors%20showing%20timeline%20and%20film%20strips%20stacked%20nearby%2C%20amber%20screen%20glow%2C%20stylized%20editorial%20photography%2C%20no%20people%2C%20high%20detail&width=800&height=600&seq=hl-topic-editing&orientation=landscape",
  },
];

export default function TopicSection() {
  return (
    <section className="max-w-portal mx-auto px-4 md:px-6 pt-12 md:pt-16">
      <SectionHeading
        eyebrow="Special Topics"
        title="专题策划"
        desc="围绕一个幕后主题，把零散的现场见闻串成一条完整的观看线索。"
      />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
        {topics.map((topic, idx) => (
          <Link
            key={topic.title}
            to={topic.href}
            className={`group relative block h-64 md:h-72 overflow-hidden rounded-lg bg-foreground-900 cursor-pointer ${
              idx === 0 ? "md:col-span-2 md:h-72" : ""
            }`}
          >
            <img
              src={topic.image}
              alt={`${topic.title} 幕后专题封面`}
              title={`${topic.title} 专题`}
              className="w-full h-full object-top object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/92 via-foreground-950/40 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
              <span className="inline-block px-2.5 py-1 rounded bg-primary-500 text-foreground-950 text-xs font-bold mb-3">
                {topic.tag}
              </span>
              <h3 className="font-heading text-xl md:text-2xl font-black text-background-50">
                {topic.title}
              </h3>
              <p className="text-sm text-background-200 leading-relaxed mt-2 line-clamp-2 max-w-md">
                {topic.desc}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}